import 'Modernizr';
import 'alpinejs';
import lax from 'lax.js'
import Swiper from 'swiper';

window.onload = function() {
	lax.setup({
		breakpoints: { small: 0, large: 768 }
	});

	const updateLax = () => {
		lax.update(window.scrollY)
		window.requestAnimationFrame(updateLax)
	}

    window.requestAnimationFrame(updateLax)
}

window.addEventListener("resize", function() {
	lax.updateElements()
});

var swiper = new Swiper('.swiper-container', {
	slidesPerView: 1,
	spaceBetween: 32,
	grabCursor: true,
	pagination: {
	  el: '.swiper-pagination',
	  clickable: true,
	},
	breakpoints: {
		640: {
		  slidesPerView: 2,
		},
	},
});